import React, { Component } from 'react';
import { Radar } from 'react-chartjs-2';
import './radar.css';

class RadarChart extends Component {

  render() {

    const { nano, micro, macro, star } = this.props.data

    const data = {
      labels: ['Nano', 'Micro', 'Macro', 'Star'],
      datasets: [
        {
          data: [nano, micro, macro, star],
          lineTension: 0.4,
          borderColor: '#F39200',
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          backgroundColor: 'rgba(255,255,255,0.3)'

        },
      ],
    }

    const options = {
      legend: {
        display: false,
      },
      scale: {
        ticks: {
          min: 0,
          max: 10,
          stepSize: 2,
          display: false,
        },
        pointLabels: {
          display: false
        },
        gridLines: {
          color: 'rgba(255,255,255,0.3)',
          circular: true,
        },
        angleLines: {
          color: 'rgba(255,255,255,0.3)'
        }
      },
      responsive: false,
    }




    return(
      <div className='radar-box'>
        <Radar data={data} options={options} width={240} height={240}/>
        <div className='radar-graph'></div>
      </div>

    )
  }
}

export default RadarChart;
